import { AssociationKeys } from '../utils/association.model';
import { LocalDateTimeString } from '../utils/local-date-time-string.model';
import { SelectedExcursionConfiguration, SelectedExcursionOptions } from '../registration/excursion.model';
import { NotifyEmail } from './notify-email.model';
import { BaseCampaignsEmail } from '../email/email-campaign.model';
import { ExcursionConfigurationsEmailKeys } from './excursion-configurations-email.model';

export enum RegistrationSummaryEmailKeys {
  hotelName = 'hotelName',
  hotelState = 'hotelState',
  hotelAddress = 'hotelAddress',
  facilityName = 'facilityName',
  coordinatorEmail = 'coordinatorEmail',
  coordinatorPrimaryPhoneNumber = 'coordinatorPrimaryPhoneNumber',
  eventName = 'eventName',
  hasChairmanExtension = 'hasChairmanExtension',
  checkInDate = 'checkInDate',
  checkOutDate = 'checkOutDate',
  chairmanCheckInDate = 'chairmanCheckInDate',
  chairmanCheckOutDate = 'chairmanCheckOutDate',
  requestedCheckInDate = 'requestedCheckInDate',
  requestedCheckOutDate = 'requestedCheckOutDate',
  eventStartDate = 'eventStartDate',
  eventEndDate = 'eventEndDate',
  hotelPhoneNumber = 'hotelPhoneNumber',
  flightItineraryEmail = 'flightItineraryEmail',
  registrationDetails = 'registrationDetails',
  transactions = 'transactions',
  excursions = 'excursions',
  chairmanExcursions = 'chairmanExcursions',
  hasDifferBookingDatesRequest = 'hasDifferBookingDatesRequest',
  hasAdditionalRoomRequest = 'hasAdditionalRoomRequest',
  travelDates = 'travelDates',
  //
  registrationType = 'registrationType',
  // transaction table
  transactionDate = 'transactionDate',
  transactionTotal = 'transactionTotal',
  transactionStatus = 'transactionStatus',
  // excursions table
  excursionsGroupedDate = 'excursionsGroupedDate',
  excursionsGroup = 'excursionsGroup',
  excursionAttendee = 'excursionAttendee',
  excursionName = 'excursionName',
  excursionPreferences = 'excursionPreferences',
  excursionDate = 'excursionDate',
}

export interface RegistrationSummaryEmailRegistrationDetail {
  [AssociationKeys.firstName]?: string;
  [AssociationKeys.lastName]?: string;
  [RegistrationSummaryEmailKeys.registrationType]?: string;
}

export interface RegistrationSummaryEmailTransaction {
  [RegistrationSummaryEmailKeys.transactionDate]?: string;
  [RegistrationSummaryEmailKeys.transactionTotal]?: string;
  [RegistrationSummaryEmailKeys.transactionStatus]?: string;
}

export interface RegistrationSummaryEmailExcursionGroup {
  [RegistrationSummaryEmailKeys.excursionAttendee]?: string;
  [RegistrationSummaryEmailKeys.excursionName]?: string;
  [RegistrationSummaryEmailKeys.excursionPreferences]?: string;
}

export interface RegistrationSummaryEmailExcursion {
  [RegistrationSummaryEmailKeys.excursionAttendee]?: string;
  [RegistrationSummaryEmailKeys.excursionDate]?: LocalDateTimeString;
  [RegistrationSummaryEmailKeys.excursionName]?: string;
  selectedPreferences?: SelectedExcursionOptions;
  configurations?: SelectedExcursionConfiguration;
}

export interface RegistrationSummaryEmailExcursionGrouped {
  [RegistrationSummaryEmailKeys.excursionsGroupedDate]?: string;
  [RegistrationSummaryEmailKeys.excursionsGroup]?: RegistrationSummaryEmailExcursionGroup[];
}

export interface RegistrationSummaryEmail extends NotifyEmail {
  [RegistrationSummaryEmailKeys.hasChairmanExtension]?: boolean;
  [RegistrationSummaryEmailKeys.checkInDate]?: LocalDateTimeString;
  [RegistrationSummaryEmailKeys.checkOutDate]?: LocalDateTimeString;
  [RegistrationSummaryEmailKeys.chairmanCheckInDate]?: LocalDateTimeString;
  [RegistrationSummaryEmailKeys.chairmanCheckOutDate]?: LocalDateTimeString;
  [RegistrationSummaryEmailKeys.requestedCheckInDate]?: LocalDateTimeString;
  [RegistrationSummaryEmailKeys.requestedCheckOutDate]?: LocalDateTimeString;
  [RegistrationSummaryEmailKeys.eventStartDate]?: LocalDateTimeString;
  [RegistrationSummaryEmailKeys.eventEndDate]?: LocalDateTimeString;
  [RegistrationSummaryEmailKeys.hotelPhoneNumber]?: string;
  [RegistrationSummaryEmailKeys.flightItineraryEmail]?: string;
  [RegistrationSummaryEmailKeys.hasDifferBookingDatesRequest]?: boolean;
  [RegistrationSummaryEmailKeys.hasAdditionalRoomRequest]?: boolean;
  [RegistrationSummaryEmailKeys.excursions]?: RegistrationSummaryEmailExcursion[];
  [RegistrationSummaryEmailKeys.chairmanExcursions]?: RegistrationSummaryEmailExcursion[];
  [RegistrationSummaryEmailKeys.registrationDetails]?: RegistrationSummaryEmailRegistrationDetail[];
  [RegistrationSummaryEmailKeys.transactions]?: RegistrationSummaryEmailTransaction[];
  [RegistrationSummaryEmailKeys.eventName]?: string;
  [RegistrationSummaryEmailKeys.hotelName]?: string;
  [RegistrationSummaryEmailKeys.hotelState]?: string;
  [RegistrationSummaryEmailKeys.hotelAddress]?: string;
  [RegistrationSummaryEmailKeys.facilityName]?: string;
  [RegistrationSummaryEmailKeys.coordinatorPrimaryPhoneNumber]?: string;
  [RegistrationSummaryEmailKeys.coordinatorEmail]?: string;
  [RegistrationSummaryEmailKeys.travelDates]?: string;
}

export class ConferenceRegistrationCampaignEmail extends BaseCampaignsEmail {
  context: RegistrationSummaryEmail;
}
